import DynamicFormWidget from "../../../widgetsExtend/DynamicFormsV2/widget";
import {WidgetType} from "../../../constants/WidgetConstants";
import React from "react";
import AtDynamicFormsWidget from "../component";
import { EventType } from "../../../constants/AppsmithActionConstants/ActionConstants";

class AtDynamicFormWidget extends DynamicFormWidget{

  onExecuteAction = (event: any) => {
    this.setState({
      isLoading: true,
    });
    let values:any = {};
    this.props.currentData.map((i:any)=>{
      values[i.id] = Array.isArray(i.value)?i.value.join(','):i.value;
    })
    super.executeAction({
      triggerPropertyName: "onClick",
      dynamicString: event,
      event: {
        type: EventType.ON_SUBMIT,
      },
      globalContext: {
        [this.props.widgetName]: values
      }
    });

  }

  getPageView() {
    return (
      <AtDynamicFormsWidget ref={this.dynamicFormRef} {...this.props}
                          onExecuteAction={this.onExecuteAction} updateWidgetMeta={this.updateWidgetMeta} />
    )
  }
  static getWidgetType(): WidgetType {
    return "AT_DYNAMIC_FORM_WIDGET";
  }
}
export default AtDynamicFormWidget;
